<mat-dialog-content class="mat-typography">
      <div id="support_number" class="p-[1rem] flex flex-col items-center ">
          <h1 class="text-3xl mb-10">¿Cómo saber mi fecha vencimiento?</h1>
          
          <div class=" section-document max-w-3xl card p-6 mb-6">
              <div class="flex flex-col md:flex-row ">
                  <div class="img-wrapper w-full">
                      <app-image-loader [src]="'img/illustrations/expiration-date-1.png' | assetUrl" alt="Fecha vencimiento DNI"></app-image-loader>
                      <br />
                      <app-image-loader [src]="'img/illustrations/expiration-date-2.png' | assetUrl" alt="Fecha vencimiento DNI"></app-image-loader>
                  </div>
              </div>
          </div>

          <h1 class="text-3xl my-10" style="text-align: center;">Y si mi DNI no tiene fecha de validez,<br>¿qué dato introduzco?</h1>

          <div class=" section-document max-w-3xl card p-6 mb-6">
            <div class="flex flex-col md:flex-row ">
                <div class="img-wrapper w-full">
                    <h2 class="text-xl" style="font-weight: bold;">La fecha de expedición del DNI</h2>
                    <br />
                    <app-image-loader [src]="'img/illustrations/expiration-date-3.png' | assetUrl" alt="Fecha vencimiento DNI"></app-image-loader>
                </div>
            </div>
          </div>
      </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button         
    [style.color]="funderStyles.colors.btnText"
    [style.background]="funderStyles.colors.btnBg"
    [style.border-radius]="funderStyles.btnRound + 'px'"
    class="px-8" 
    mat-flat-button type="button" [mat-dialog-close]="true" cdkFocusInitial>Aceptar</button>
</mat-dialog-actions>